import Swal from 'sweetalert2';

export function useAlert() {
    const toast = (message, icon = 'info') => {
        Swal.fire({
            title: message,
            icon: icon,
            timer: 2000,
            showConfirmButton: false,
            toast: true,
            position: 'top-end'
        });
    };

    const confirm = async (title = 'Are you sure?', text = "You won't be able to revert this!") => {
        const result = await Swal.fire({
            title: title,
            text: text,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, proceed!'
        });
        return result.isConfirmed;
    };

    const success = (title, text = '') => {
        Swal.fire({
            title: title,
            text: text,
            icon: 'success'
        });
    };

    const error = (title, text = '') => {
        Swal.fire({
            title: title,
            text: text,
            icon: 'error'
        });
    };

    return {
        toast,
        confirm,
        success,
        error
    };
}
